<template>
    <v-container>
        <message-component 
            id="message" 
            v-model="isMessage" 
            :success="success"
        >{{ message }}</message-component>
        <v-container class="mt-4">
            <v-row>
                <v-col cols="12" xl="6" class="text-h4">
                    グループ一覧
                </v-col>
            </v-row>
        </v-container>
        <v-row>
            <template v-if="userRoleAdmin">
                <v-col 
                    cols="12"
                    class="text-right pr-10 pt-0"
                >
                    <v-btn 
                        color="orange" 
                        class="white--text" 
                        @click="addItem"
                    >
                        追加
                    </v-btn>
                </v-col>
            </template>
        </v-row>
        <v-container>
            <v-data-table
                :headers="headers"
                :items="items"
                hide-default-footer
                disable-pagination
                no-data-text="追加されたグループはありません"
            >
                <template v-slot:item.needs_approval="{ item }">
                    {{ item.needs_approval ? 'ON' : 'OFF'}}
                </template>
                
                <template v-slot:item.actions="{ item }">
                    <template v-if="userRoleAdmin">
                        <v-btn 
                            color="blue" 
                            class="white--text mr-4" 
                            @click="editItem(item)"
                        >
                            詳細
                        </v-btn>
                        <v-btn 
                            color="blue-grey" 
                            class="white--text mr-4" 
                            @click="deleteItem(item)"
                        >
                            削除
                        </v-btn>
                    </template>
                    
                    <v-btn
                        color="orange"
                        class="white--text"
                        :href="'/documents/organization-users/' + item.id"
                    >
                        グループメンバー
                    </v-btn>
                </template>
                
            </v-data-table>
        </v-container>
        
        <dialog-component 
            v-if="dialog" 
            :dialog.sync="dialog" 
            :item="{id: currentItem.id, name: currentItem.name, needs_approval: currentItem.needs_approval}"
            @success="getOrganizationList" 
            @error="error"
        ></dialog-component>
        
        <delete-dialog-component 
            v-if="deleteDialog" 
            :deleteDialog.sync="deleteDialog" 
            :item="{id: currentItem.id, table: '/documents/delete-organizations/'}"
            @success="getOrganizationList" 
            @error="error"
        >
            <template v-slot:title>{{ currentItem.name }} を削除しますか？</template>
            <template v-slot:ok-btn>削除</template>
            <template v-slot:cancel-btn>キャンセル</template>
        </delete-dialog-component>
    </v-container>
</template>

<script>
    import DialogComponent from "./DialogComponent";
    export default {
        data() {
            return {
                dialog: false,
                deleteDialog: false,
                headers: [
                    {
                        text: 'グループ名',
                        align: 'start',
                        width: 40,
                        sortable: false,
                        value: 'name'
                    },
                    { 
                        text: '承認者必須', 
                        sortable: false,
                        width: 30,
                        value: 'needs_approval' 
                    },
                    { 
                        text: '', 
                        align: 'end',
                        sortable: false,
                        width: 30,
                        value: 'actions' 
                    },
                ],
                items: [],
                message: null,
                success: false,
            };
        },
        components: {
            'dialog-component': DialogComponent
        },
        computed: {
            isMessage: {
                get() {
                    return this.message != null;
                },
                set(value) {
                    if (!value) {
                        this.message = null;
                    }
                }
            },
            userRoleAdmin () {
                return this.userRole == 1 ? true : false;
            },
        },
        methods: {
            addItem() {
                this.dialog = true;
                this.currentItem = '';
            },
            editItem(item) {
                this.dialog = true;
                this.currentItem = item;
            },
            deleteItem(item) {
                this.deleteDialog = true;
                this.currentItem = item;
            },
            error(message) {
                this.success = false;
                this.message = message;
            },
            getOrganizationList(message) {
                axios.get("/documents/get-organizations").then(res => {
                    this.items = res.data.organizationList;
                    this.success = true;
                    this.message = message;
                }).catch(res => {
                    this.success = false;
                    this.message = "取得処理に失敗しました";
                });
            }
        },
        mounted() {
            this.getOrganizationList();
        },
        props: ['userRole']
    };
</script>

<style scoped>
    .v-btn:not(.v-btn--round).v-size--default {
        margin: 2px 0;
    }
</style>